import React from 'react';
import { BloxButton } from 'styled_components/Common/BloxButton';
import { Divider } from 'styled_components/Common/Divider';
//import { string, func, bool, object } from 'prop-types';
import styled from 'styled-components';

const FooterContainer = styled.div`
	position: relative;
	width: 100%;
	height: 72px;
	min-height: 72px;
	display: flex;
	justify-content: center;
	align-items: center;
	#button-2 {
		margin-left: 24px;
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		height: 80px;
		min-height: 80px;
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		height: 128px;
		min-height: 128px;
		#button-2 {
			margin-left: 32px;
		}
	}
`;

export const Footer = ({
	cypressId,
	id,
	buttonText1,
	buttonText2,
	module,
	buttonFunction1,
	buttonFunction2,
}) => {
	return (
		<FooterContainer id={id} className=''>
			<span>
				<Divider />
				{buttonFunction1 && (
					<BloxButton
						id={`button-1`}
						text={buttonText1}
						module={module}
						enabled={true}
						cypressId={cypressId}
						className='buttons41'
						onClick={buttonFunction1}
					/>
				)}
				{buttonFunction2 && (
					<BloxButton
						id={`button-2`}
						text={buttonText2}
						module={module}
						enabled={true}
						className='buttons41'
						onClick={buttonFunction2}
					/>
				)}
			</span>
		</FooterContainer>
	);
};

// PopUp.propTypes = {
// 	showModal: bool,
// 	id: string,
// 	closeModal: func.isRequired,
// 	onClick: func,
// 	title: string,
// 	text: string,
// 	cypressId: string,
// 	footer: object,
// };

// PopUp.defaultProps = {
// 	showModal: false,
// 	id: '',
// 	onClick: () => {},
// 	title: 'Modal Title',
// 	text: 'Modal text',
// 	cypressId: 'pop-up-modal',
// 	footer: (
// 		<BloxButton
// 			className='buttons41'
// 			id='okay'
// 			text='OKAY'
// 			module='support'
// 			enabled={true}
// 			onClick={() => {}}
// 			cypressId='okay'
// 		/>
// 	),
// };
